/* eslint-disable no-param-reassign */
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Input,
  List,
  ListItem,
  Switch,
} from '@chakra-ui/react';
import { FC, useState } from 'react';
import { AiFillDelete } from 'react-icons/ai';
import { VtexWhitelistMethod, VtexWhiteListPath } from '../models/whitelist';

type WhitelistListProps = {
  paths: VtexWhiteListPath[];
  onDelete: (index: number) => void;
};

type WhitelistItemProps = {
  path: VtexWhiteListPath;
  onDelete: () => void;
};

const WhitelistItem: FC<WhitelistItemProps> = ({ path, onDelete }) => {
  const [pathString, setPathString] = useState(path.path);
  const [isActive, setIsActive] = useState(path.enabled);
  const [isPublic, setIsPublic] = useState(path.isPublic);
  const [methods, setMethods] = useState(path.method);

  const handleRemove = () => {
    const confirm = window.confirm(
      `Deseja realmente remover o path? (${path.path})`,
    );
    if (confirm) {
      onDelete();
    }
  };

  return (
    <ListItem>
      <Box bg="white" w={{ sm: '100%', md: '300px' }} p="4">
        <Flex gridGap="2">
          <Switch
            id="isActive"
            size="sm"
            isChecked={isActive}
            onChange={e => {
              path.enabled = e.target.checked;
              setIsActive(e.target.checked);
            }}
          />
          <Box w="full">
            <Input
              size="xs"
              value={pathString}
              onChange={e => {
                path.path = e.target.value;
                setPathString(e.target.value);
              }}
            />
            <FormControl
              display="flex"
              flexWrap="wrap"
              alignItems="center"
              gridGap="1"
            >
              {Object.keys(VtexWhitelistMethod).map((method: any) => (
                <Checkbox
                  key={method}
                  size="sm"
                  mr="1"
                  isChecked={path.method.includes(method)}
                  onChange={e => {
                    if (e.target.checked) {
                      path.method.push(method);
                    } else {
                      path.method = path.method.filter(m => m !== method);
                    }
                    setMethods([...path.method]);
                  }}
                >
                  {method}
                </Checkbox>
              ))}
            </FormControl>
            <Divider my="2" />
            <FormControl
              display="flex"
              flexWrap="wrap"
              alignItems="center"
              gridGap="1"
            >
              <FormLabel
                htmlFor="isPublic"
                fontWeight="normal"
                fontSize="sm"
                m="0"
              >
                Público
              </FormLabel>
              <Checkbox
                id="isPublic"
                size="sm"
                isChecked={isPublic}
                onChange={e => {
                  path.isPublic = e.target.checked;
                  setIsPublic(e.target.checked);
                }}
              />
              <Button
                p="1"
                ml="auto"
                h="fit-content"
                minW="fit-content"
                bg="transparent"
                onClick={handleRemove}
              >
                <AiFillDelete color="red" />
              </Button>
            </FormControl>
          </Box>
        </Flex>
      </Box>
    </ListItem>
  );
};

const WhitelistList: FC<WhitelistListProps> = ({ paths, onDelete }) => {
  const handleDelete = (index: number) => {
    onDelete(index);
  };
  return (
    <List
      h="350px"
      w={{ sm: '100%', md: '650px', lg: '950px' }}
      overflow="auto"
      flexWrap="wrap"
      display="flex"
      gridGap="2"
      alignItems="center"
    >
      {paths.map((path, index) => {
        return (
          <WhitelistItem
            key={path.path}
            path={path}
            onDelete={() => handleDelete(index)}
          />
        );
      })}
    </List>
  );
};

export default WhitelistList;
